import { render, staticRenderFns } from "./MasterColorGroupTop.vue?vue&type=template&id=21cc27c1&scoped=true&"
import script from "./MasterColorGroupTop.vue?vue&type=script&lang=js&"
export * from "./MasterColorGroupTop.vue?vue&type=script&lang=js&"
import style0 from "./MasterColorGroupTop.vue?vue&type=style&index=0&id=21cc27c1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cc27c1",
  null
  
)

export default component.exports